import { render } from "./SlotList.vue?vue&type=template&id=53e7860a&scoped=true"
import script from "./SlotList.vue?vue&type=script&lang=js"
export * from "./SlotList.vue?vue&type=script&lang=js"

import "./SlotList.vue?vue&type=style&index=0&id=53e7860a&scoped=true&lang=css"
import "./SlotList.vue?vue&type=style&index=1&id=53e7860a&lang=css"

import exportComponent from "../../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e7860a"]])

export default __exports__